import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "io-slider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Slider, {
      key: `io-slider-${_ctx.max}`,
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      min: _ctx.min,
      max: _ctx.max,
      step: _ctx.step,
      tooltips: _ctx.tooltip,
      "show-tooltip": _ctx.tooltipShow,
      format: _ctx.tooltipFormat,
      onChange: _ctx.emitChange
    }, null, 8, ["modelValue", "min", "max", "step", "tooltips", "show-tooltip", "format", "onChange"])
  ]))
}